// extracted by mini-css-extract-plugin
export default {"CollapseStyle":"LeftInfo_CollapseStyle__Fskd1"};